import { render, staticRenderFns } from "./iddMovieOverview.vue?vue&type=template&id=0032277e&scoped=true"
import script from "./iddMovieOverview.vue?vue&type=script&lang=js"
export * from "./iddMovieOverview.vue?vue&type=script&lang=js"
import style0 from "./iddMovieOverview.vue?vue&type=style&index=0&id=0032277e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0032277e",
  null
  
)

export default component.exports